<script setup lang="ts">
import Footer from '~/components/layout/Footer.vue'
import NavigationBar from '~/components/layout/NavigationBar.vue'

const { initLenis, destroyLenis } = useLenis()

onMounted(() => {
  initLenis()
})

onUnmounted(() => {
  destroyLenis()
})

useHead({
  title: 'Tentang Rintisan',
})
</script>

<template>
  <main class="min-h-screen bg-white landing-page">
    <NavigationBar />

    <hr>

    <section class="container mx-auto my-24 md:my-32 px-4">
      <div class="grid grid-cols-1 items-center gap-5 md:grid-cols-2">
        <div class="col-span-1">
          <h1 class="text-4xl font-bold text-neutral-800">
            Memulai usaha lebih mudah <br>
            bersama Rintisan
          </h1>
          <p class="mt-7 text-lg text-neutral-700">
            Rintisan adalah sebuah marketplace peluang usaha dan lisensi bisnis
            <br>
            terbesar di Indonesia. Rintisan memberdayakan UMKM melalui platform
            <br>
            digital mengembangkan skala model waralaba mereka dan untuk <br>
            membuat sebuah ekosistem bisnis yang kohesif.
          </p>
        </div>
        <div class="col-span-1">
          <img
            class="mx-auto w-11/12 object-contain"
            src="/images/primary/aboutRintisanImage.png"
            alt="headerImage"
          >
        </div>
      </div>
    </section>

    <section class="bg-[#F8F8F8] py-16 text-center">
      <div class="container relative mx-auto px-4">
        <img
          class="absolute left-20 -top-24 hidden md:block"
          src="/images/primary/quotes.png"
          alt="quotesIcon"
        >
        <h1 class="text-2xl font-bold text-neutral-800">
          Kami menciptakan bagaimana peluang bisnis dan waralaba <br>
          ditingkatkan menjadi sebuah
          <span class="bg-linear-to-r from-[#2563eb] to-[#7c3aed] bg-clip-text text-transparent">#WaralabaHebat</span>
        </h1>
        <img
          class="absolute right-20 -bottom-24 hidden rotate-180 transform md:block"
          src="/images/primary/quotes.png"
          alt="quotesIcon"
        >
      </div>
    </section>

    <section class="container mx-auto mt-36 mb-52 px-4">
      <h1 class="text-center text-4xl font-bold text-neutral-800">
        Rintisan memiliki sebuah misi
      </h1>
      <p class="mt-5 text-center text-base text-neutral-700">
        Rintisan dibangun berdasarkan gagasan bahwa setiap bisnis dapat dibangun
        dengan lebih <br>
        cerdas. Melalui design, sistem dan support, kami membuka peluang untuk
        setiap pemilik bisnis <br>
        dapat bekerja lebih produktif dan menguntungkan.
      </p>
      <img
        class="mt-16 w-full"
        src="/images/primary/aboutRitisanImageContent.jpeg"
        alt="imageContentAbout"
      >
    </section>

    <Footer />
  </main>
</template>
